export default __webpack_public_path__ + "static/media/k_wdt_c_0.d680cefe.mp3";